module.exports = __webpack_public_path__ + "assets/img/Compose_History.ce94ef63.svg";